import {
    useEffect,
    useState
} from 'react';
import { useSelector } from 'react-redux';

import { gettr } from '../selectors/utils';

export const useLocale = () => {
    const [ locale,
        setLocale ] = useState('ru');
    const data = useSelector(gettr('selections.data.locale', 'ru'));

    useEffect(() => {
        setLocale(data);
    }, [ data ]);

    return locale;
};
